var form_toggle = {
    init: function() {
        var self = this;
       // checkContent();   
    }
}

function form_toggle_fnc(){
    var myInputs = document.querySelectorAll('.product_wrap .wpcf7-text, .product_wrap .wpcf7-textarea');

    myInputs.forEach(function(input) {
        input.addEventListener('blur', handleEventBlur);
        input.addEventListener('focus', handleEvent);
    });
}
function handleEventBlur(e) {
    e.preventDefault();
    var $this = jQuery(this);
    var $toggleText = $this.next('.toggle_text');
    $toggleText.remove();
    $this.parent().css("background-color", "#ffffff");
}
function handleEvent(e) {
    e.preventDefault();
    
    var $this = jQuery(this);
    
    $this.after("<span class='toggle_text'>" + $this.attr('placeholder') + "</span>");
    $this.parent().css("background-color", "#b1b1b1");
}
export {
    form_toggle
};
